/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import { compose } from 'recompose';
import {
    object, string, func, node, bool, shape, arrayOf, number,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { useMediaQuery } from '@material-ui/core';
import GraphqlProductImageUI from './Partials/ProductImageUI/GraphqlProductImageUI';
import PDPAddToCart from './Partials/PDPAddToCart/PDPAddToCart';
import GraphqlClubDescription from './Partials/GraphqlClubDescription/GraphqlClubDescription';
import {
    addonGroupsType, clubComponentType, selectedSkuType, UpsellType, productType, skuDataType, skuConfigType, passportImageType, deliveryDataType, addToCartDataType,
} from './Partials/common/types';
import { actions as tagManagerActions } from '../../../../state/ducks/TagManager';
import { getFeatureFlags, getBrand } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';

import ProductReview from './Partials/ProductReview';
import GraphqlFoodProductSkus from './Partials/GraphqlPDPSkus/GraphqlFoodProductSkus';
import GraphqlAddonContainer from './Partials/GraphqlAddon/GraphqlAddonContainer';
import GCIPersonalization from './Partials/CGC/GCIPersonalization';
import SnipeBanner from './Partials/ExpressShip/SnipeBanner';
import GraphqlAgeVerification from './Partials/CommonProductAgeZipVerify/CommonProductAgeZipVerify';
import PersonalizeYourGift from './Partials/PersonalizeYourGift/PersonalizeYourGift';
import GoDeluxe from './Partials/GraphqlPDPSkus/GoDeluxe';
import OneClickPaymentBuilder from './Partials/OneClickPayments/OneClickPaymentBuilder';
import PassportBannerUI from '../../../pages/Checkout/containers/CheckoutFloral/Partials/Passport/PassportBannerUI/PassportBannerUI';
import GraphqlPDPPromoContainer from './Partials/GraphqlPDPPromotionBlock/GraphqlPDPPromoContainer';
import ModalWrapper from '../../../pages/Checkout/containers/Common/ModalWrapper/ModalWrapper';
import ShippingInfo from '../../../pages/Checkout/containers/CheckoutFood/components/AddPayment/Partials/OrderTotalSummary/Partials/ShippingInfo/ShippingInfoCMS';
import PassportBannerContainer from './Partials/StandardProductsPage/PassportBannerContainer';
import { getBaseCode } from '../../../helpers/tracking/product/dataLayerProductHelpers';
import GraphqlClubDescriptionV2 from './Partials/GraphqlClubSelectionV2/GraphqlClubDescriptionV2';
import GraphqlWineDisclaimer from './Partials/GraphqlWineDisclaimer/WineDisclaimerContainer';
import { getCurrentPageType } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Selectors';
import QuestionsAndAnswersAI from './Partials/QuestionsAndAnswers/QuestionsAndAnswersAI';
import YotpoClickEvent from './Partials/StandardProductsPage/YotpoClickEvent';

const ClubPDPContainerMaxWidth = 1280;

const styles = (theme) => ({

    breadcrumbs: {
        maxWidth: ClubPDPContainerMaxWidth,
        margin: '0 auto',
    },
    contentTop: {
        display: 'flex',
        margin: '0px auto',
        maxWidth: ClubPDPContainerMaxWidth,
        color: theme.palette.black,
        '& >div': {
            width: '100%',
        },
        [theme.breakpoints.down('md')]: {
            marginTop: '25px',
        },
        '& .add-to-cart-container': {
            width: '95%',
            margin: '0 auto',
        },
        '@media screen and (max-width: 600px)': {
            padding: '0px 8px',
        },
    },
    prReviewDisplay: {
        '& .p-w-r .pr-review-snapshot .pr-review-snapshot-simple .pr-review-snapshot-snippets-headline': {
            marginRight: '10px',
        },
        '& .pr-snippet': {
            display: 'flex',
            minWidth: 'fit-content',
        },
        '& .p-w-r .modal__body .pr-read-review-flagging-in .pr-rd-helpful-action-btn-group': {
            display: 'flex',
        },
        '& .pr-rd-helpful-action-group': {
            display: 'flex',
        },
        [theme?.breakpoints?.down('980')]: {
            '& .p-w-r .pr-review-snapshot .pr-snippet .pr-snippet-stars-png .pr-star-v4': {
                height: '15px',
                width: '15px',
            },
            '& .p-w-r .pr-review-snapshot.pr-snapshot-mobile .pr-review-snapshot-simple .pr-snippet-rating-decimal': {
                display: 'none',
            },
            '& .pr-review-snapshot-snippets': {
                justifyContent: 'left',
            },
            '& .p-w-r .pr-review-display .pr-rd-helpful-action .pr-rd-helpful-text': {
                display: 'block',
            },
            '& .pr-rd-flag-review-container': {
                display: 'block',
            },
        },
        [theme?.breakpoints?.down('sm')]: {
            '& .pr-snippet': {
                flexDirection: 'column',
            },
        },
        [theme?.breakpoints?.down('xs')]: {
            '& .p-w-r .pr-review-display .pr-rd-helpful-action .pr-rd-helpful-text': {
                display: 'none',
            },
            '& .pr-rd-flag-review-container': {
                display: 'none',
            },
            '& .pr-snippet': {
                flexDirection: 'column',
            },
        },
    },
    yotpoContainer: {
        width: '100%',
        margin: '0 auto',
        maxWidth: ClubPDPContainerMaxWidth,
        // Tablet
        [theme.breakpoints.down('md')]: {
            padding: '0 20px 0',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 15px 0',
            padding: '0',
        },
    },
    productReviewContainer: {
        width: '100%',
        margin: '0 auto',
        maxWidth: ClubPDPContainerMaxWidth,
        // Tablet
        [theme.breakpoints.down('md')]: {
            padding: '0 20px 0',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 15px 0',
            padding: '0',
        },
    },
    contentLeft: {
        width: '100%',
        maxWidth: 480,
        [theme.breakpoints.down('md')]: {
            maxWidth: 'none',
            minWidth: 'auto',
            float: 'left',
        },
    },
    contentRight: {
        width: '100%',
        maxWidth: 510,
    },
    imageSection: {
        paddingRight: 15,
        [theme?.breakpoints?.down('sm')]: {
            paddingRight: 0,
        },
    },
    rightPanel: {
        [theme?.breakpoints?.up(1023)]: {
            padding: '0 0.5rem 0 1rem',
        },
    },
    clubPdpV2Contianer: {
        maxWidth: '1400px',
        '& $imageSection': {
            paddingRight: 15,
            position: 'sticky',
            top: '0',
            [theme?.breakpoints?.down('xs')]: {
                paddingRight: 0,
            },
        },
    },
    clubPdpContainer: {
        '@media screen and (max-width: 960px)': {
            padding: '0px 8px',
        },
    },
    wineContainer: {
        maxWidth: '1400px',
        margin: '0 auto',
        '@media screen and (max-width:600px)': {
            padding: '0px 8px',
        },
    },
    prQuestionDisplay: {
        '& .p-w-r .pr-waqwaa': {
            maxWidth: '100%',
        },
        '& .p-w-r .pr-qa-display .pr-btn-ask-question .pr-cross-icon': {
            display: 'none',
        },
    },
    hidePRStarDistribution: {
        '& .p-w-r .pr-review-snapshot.pr-review-enhanced .pr-review-snapshot-block-container .pr-review-snapshot-block:last-child': {
            display: 'none',
        },
    },
});

const GraphqlClubProductPage = ({
    product,
    brand,
    featureFlags,
    location,
    selectedSku,
    classes,
    presentation_family,
    handleSkuChange,
    sortedData,
    skuConfig,
    deliveryData,
    breadCrumbArray,
    passportMemberImg,
    productUrl,
    breadcrumbs,
    skuMonths,
    changeClubMonth,
    changeClubLength,
    clubUpsells,
    clubComponents,
    shortDescription,
    longDescription,
    selectedClubUpsells,
    trackEvent,
    changeClubUpsell,
    hasAddons,
    handlePersonalizeInputChange,
    getUpdatedPersonalizedProdData,
    disableAddToCart,
    personalizedData,
    personalization,
    isAddToCartEnabled,
    handleMiniCartModalClick,
    mobileAgeVerificationOpen,
    handleMobileAgeVerification,
    addToCartData,
    hasWine,
    isPassportEnabled,
    addonGroups,
    deliverySLA,
    deviceType,
    deliveryIndicator,
    isPassportAfterCta,
}) => {
    const [shippingModalOpen, setShippingModalOpen] = useState(false);
    const wineModelOnAction = featureFlags['is-inline-wine-verification-model-on-atc-enabled'] || false;
    const isMobile = useMediaQuery('(max-width: 600px)');
    const isClubPDPV2 = featureFlags['is-club-pdp-v2'];
    const dispatch = useDispatch();

    const { clickableDivRef } = YotpoClickEvent(dispatch);
    const compileSelectedItems = () => {
        const selectedMonthSku = product?.club?.defaultSku?.components.find((item) => item?.month?.toLowerCase() === selectedSku?.date?.month?.toLowerCase());
        const productArray = [];
        productArray.push({
            brandCode: selectedSku?.brandId,
            productCode: selectedMonthSku?.partNumber,
            quantity: selectedSku?.quantity || 1,
            componentType: selectedSku?.productType,
        });
        return productArray;
    };
    const pageType = useSelector(getCurrentPageType);
    const questionAndAnswersAIEnabled = featureFlags['ai-questions-and-answers-pdp'];

    const showAggregatedRating = () => (featureFlags['is-show-product-reviews-aggregated-star-rating'] ? 'gold-stars' : 'pr-Review-Image-Display-Disclaimer pr-reviewdisplay-no-aggregated-star-rating black-stars');
    const showRatingDistribution = () => (featureFlags['is-show-product-reviews-star-distribution'] ? '' : classes.hidePRStarDistribution);

    return (
        <>
            <div className={isClubPDPV2 ? `${classes.clubPdpV2Contianer} ${classes.breadcrumbs}` : classes.breadcrumbs}>{breadcrumbs}</div>
            <ModalWrapper
                modalTitle="Shipping Charges"
                modalContent={<ShippingInfo />}
                isOpen={shippingModalOpen}
                onCloseModal={() => setShippingModalOpen(false)}
                btnClose
                modalSize={deviceType === 'mobile' ? 'lg' : 'md'}
            />
            <Grid container direction="row" justify="space-between" className={isClubPDPV2 ? `${classes.clubPdpV2Contianer} ${classes.contentTop}` : `${classes.clubPdpContainer} ${classes.contentTop}`}>
                <Grid xs={12} sm={isClubPDPV2 ? 5 : 12} lg={isClubPDPV2 ? 6 : 5} md={5} item>
                    <div className={classes.imageSection}>
                        <GraphqlProductImageUI
                            isClubProduct
                            data={product}
                            clubComponents={clubComponents}
                            selectedSku={selectedSku}
                            location={location}
                            presentation_family={presentation_family}
                            setShippingModalOpen={setShippingModalOpen}
                            productUrl={productUrl}
                            isClubPDPV2={isClubPDPV2}
                        />
                    </div>
                </Grid>
                <Grid xs={12} sm={isClubPDPV2 ? 7 : 12} lg={isClubPDPV2 ? 6 : 7} md={7} item className={classes.rightPanel}>
                    {!isMobile && featureFlags['is-pdp-reviews-enabled'] && featureFlags['is-power-review-enabled'] && (
                        <ProductReview
                            product={product}
                            selectedSku={selectedSku}
                            productUrl={productUrl}
                        />
                    )}

                    <GraphqlPDPPromoContainer
                        parentCategories={product.parentCategories}
                        categoryId={location.state?.categoryId || ''}
                        position="Top"
                        clubProductPage={!!isClubPDPV2}
                    />

                    <GraphqlFoodProductSkus
                        skuData={sortedData}
                        clubProduct
                        handleSkuChange={handleSkuChange}
                        trackEvent={trackEvent}
                        selectedSku={selectedSku}
                        product={product}
                        productUrl={productUrl}
                        clubComponents={clubComponents}
                        presentation_family={presentation_family}
                        location={location}
                        brand={brand}
                        skuMonths={skuMonths}
                        changeClubMonth={changeClubMonth}
                        changeClubLength={changeClubLength}
                        clubUpsells={clubUpsells}
                        selectedClubUpsells={selectedClubUpsells}
                        changeClubUpsell={changeClubUpsell}
                        baseProductSku={null}
                        showSkuOnMobile={skuConfig?.show_sku_on_mobile}
                        isPassportBundleProduct={{}}
                        setShippingModalOpen={setShippingModalOpen}
                        isClubPDPV2={isClubPDPV2}
                    />

                    <GraphqlAddonContainer
                        product={product}
                        skuData={sortedData}
                        brand={{ domain: product.brand || brand.domain }}
                        handleMiniCartModalClick={handleMiniCartModalClick}
                        brandId={brand?.id}
                        partNumber={product?.partNumber}
                        categoryId={location.state?.categoryId || ''}
                        presentation_family={presentation_family}
                        disableAddToCart={disableAddToCart}
                        isAddToCartEnabled={isAddToCartEnabled}
                        categoryPath={location.state?.categoryPath || ''}
                        categoryName={location.state?.categoryName || ''}
                        selectedSku={selectedSku}
                        productSkus={product?.productSkus}
                        deliveryData={deliveryData}
                        mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                        handleMobileAgeVerification={handleMobileAgeVerification}
                        addToCartData={addToCartData}
                        addonGroups={product?.addonGroups}
                    />

                    <GCIPersonalization
                        selectedSku={selectedSku}
                        getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
                    />

                    <SnipeBanner
                        productName={product?.image?.name}
                    />

                    {!wineModelOnAction && (
                        <GraphqlAgeVerification
                            selectedSku={selectedSku}
                            deliveryData={deliveryData}
                            productSkus={product?.productSkus}
                            mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                            handleMobileAgeVerification={handleMobileAgeVerification}
                            addToCartData={addToCartData}
                            components={selectedSku?.productType === 'CLUB' ? compileSelectedItems() : []}
                            defaultSku={selectedSku?.productType === 'CLUB' ? product?.club?.defaultSku?.partNumber : selectedSku?.id}
                        />
                    )}

                    <PersonalizeYourGift
                        selectedSku={selectedSku}
                        product={product}
                        personalization={personalization}
                        handlePersonalizeInputChange={handlePersonalizeInputChange}
                        getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
                    />

                    <GraphqlPDPPromoContainer
                        parentCategories={product.parentCategories}
                        categoryId={location.state?.categoryId || ''}
                        position="Bottom"
                    />

                    {isPassportEnabled && !isPassportAfterCta && (
                        <PassportBannerContainer selectedSku={selectedSku}>
                            <PassportBannerUI
                                bannerOnPage="product"
                                product={product}
                                location={location}
                                passportMemberImg={passportMemberImg}
                            />
                        </PassportBannerContainer>
                    )}

                    <PDPAddToCart
                        clubProduct
                        product={product}
                        clubUpsells={clubUpsells}
                        skuMonths={skuMonths}
                        changeClubMonth={changeClubMonth}
                        changeClubLength={changeClubLength}
                        skuConfig={skuConfig}
                        deliveryData={deliveryData}
                        breadCrumbArray={breadCrumbArray}
                        presentation_family={presentation_family}
                        selectedSku={selectedSku}
                        handleSkuChange={handleSkuChange}
                        sortedData={sortedData}
                        passportMemberImg={passportMemberImg}
                        productUrl={productUrl}
                        location={location}
                        selectedClubUpsells={selectedClubUpsells}
                        changeClubUpsell={changeClubUpsell}
                        hasAddons={hasAddons}
                        handlePersonalizeInputChange={handlePersonalizeInputChange}
                        disableAddToCart={disableAddToCart}
                        getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
                        personalizedData={personalizedData}
                        personalization={personalization}
                        isAddToCartEnabled={isAddToCartEnabled}
                        handleMiniCartModalClick={handleMiniCartModalClick}
                        mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                        handleMobileAgeVerification={handleMobileAgeVerification}
                        addToCartData={addToCartData}
                        hasWine={hasWine}
                        addonGroups={addonGroups}
                        deliverySLA={deliverySLA}
                        deviceType={deviceType}
                        deliveryIndicator={deliveryIndicator}
                    />
                    {isPassportEnabled && isPassportAfterCta && (
                        <PassportBannerContainer selectedSku={selectedSku}>
                            <PassportBannerUI
                                bannerOnPage="product"
                                product={product}
                                location={location}
                                passportMemberImg={passportMemberImg}
                            />
                        </PassportBannerContainer>
                    )}
                    {presentation_family === 'food' && (
                        <OneClickPaymentBuilder
                            selectedSku={selectedSku}
                            hasWine={hasWine}
                        />
                    )}

                    <GoDeluxe
                        selectedSku={selectedSku}
                        handleSkuChange={handleSkuChange}
                        goDeluxeUpsells={product?.upsells}
                        clubProduct
                        sortedData={sortedData}
                    />
                    {isClubPDPV2 && (
                        <div className={classes.contentTop}>
                            <GraphqlClubDescriptionV2
                                shortDescription={shortDescription}
                                clubComponents={clubComponents}
                                longDescription={longDescription}

                            />
                        </div>
                    )}

                    {questionAndAnswersAIEnabled ? (
                        <QuestionsAndAnswersAI
                            product={product}
                            selectedSku={selectedSku}
                            featureFlags={featureFlags}
                        />
                    ) : null}

                </Grid>
            </Grid>
            {selectedSku?.ageVerifyFlag === 'true' && isClubPDPV2 && (
                <div className={classes.wineContainer}>
                    <GraphqlWineDisclaimer />
                </div>
            )}
            {!isClubPDPV2 && (
                <div className={classes.contentTop}>
                    <GraphqlClubDescription
                        selectedSku={selectedSku}
                        setShippingModalOpen={setShippingModalOpen}
                        isPassportEligible={product?.isPassportEligible}
                        shortDescription={shortDescription}
                        clubComponents={clubComponents}
                        longDescription={longDescription}
                        productName={product?.name}
                        featureFlags={featureFlags}
                    />
                </div>
            )}
            {/* Need confirmation if FF and AB test for yotpo still needed once PR is good to go */}
            {featureFlags['is-pdp-reviews-enabled'] && featureFlags['is-power-review-enabled']
                && (
                    <div className={isClubPDPV2 ? `${classes.clubPdpV2Contianer} ${classes.productReviewContainer}` : classes.productReviewContainer}>
                        <div
                            id="pr-reviewdisplay"
                            className={`${classes.prReviewDisplay} pr-Review-Display-Snapshot-Mobile ${showAggregatedRating()} ${showRatingDistribution()}`}
                        />
                        <div
                            id="pr-questiondisplay"
                            className={classes.prQuestionDisplay}
                        />
                    </div>
                )}
            {featureFlags['is-pdp-yotpo-enabled'] && featureFlags['is-pdp-reviews-enabled'] && (
                <div className={isClubPDPV2 ? `${classes.clubPdpV2Contianer} ${classes.yotpoContainer}` : classes.yotpoContainer}>
                    <div
                        ref={clickableDivRef}
                        data-product-id={getBaseCode(product.partNumber)}
                        data-price={selectedSku.prices?.[1]?.value}
                        data-currency="USD"
                        data-name={product.name}
                        data-url={location.pathname}
                        data-image-url={`${product.image?.path}${product.image?.name}x.jpg`}
                    />
                </div>
            )}
        </>
    );
};
GraphqlClubProductPage.defaultProps = {
    longDescription: '',
    shortDescription: '',
    selectedClubUpsells: null,
    getUpdatedPersonalizedProdData: () => { },
    handlePersonalizeInputChange: () => { },
    trackEvent: () => { },
    hasAddons: false,
    disableAddToCart: false,
    isAddToCartEnabled: true,
    personalizedData: {},
    personalization: {},
    mobileAgeVerificationOpen: false,
    handleMobileAgeVerification: func,
    addToCartData: {},
    hasWine: false,
    isPassportEnabled: false,
    addonGroups: [],
    deviceType: '',
    isPassportAfterCta: false,
};

GraphqlClubProductPage.propTypes = {
    classes: object.isRequired,
    brand: object.isRequired,
    featureFlags: object.isRequired,
    trackEvent: func,
    location: object.isRequired,
    product: productType.isRequired,
    selectedSku: selectedSkuType.isRequired,
    presentation_family: string.isRequired,
    handleSkuChange: func.isRequired,
    sortedData: skuDataType.isRequired,
    skuConfig: skuConfigType.isRequired,
    deliveryData: deliveryDataType.isRequired,
    breadCrumbArray: node.isRequired,
    passportMemberImg: passportImageType.isRequired,
    productUrl: string.isRequired,
    breadcrumbs: node.isRequired,
    skuMonths: object.isRequired, // dynamic month named keys
    changeClubMonth: func.isRequired,
    changeClubLength: func.isRequired,
    clubUpsells: UpsellType.isRequired,
    clubComponents: clubComponentType.isRequired,
    longDescription: string,
    shortDescription: string,
    changeClubUpsell: func.isRequired,
    selectedClubUpsells: string,
    hasAddons: bool,
    handlePersonalizeInputChange: func,
    handleMiniCartModalClick: func.isRequired,
    getUpdatedPersonalizedProdData: func,
    disableAddToCart: bool,
    isAddToCartEnabled: bool,
    isPassportEnabled: bool,
    personalizedData: shape({
        personalizationType: string,
        personalizationLines: arrayOf({
            perAttributeValue: string,
        }),
    }),
    personalization: shape({
        lines: arrayOf(
            shape({
                lineNumber: number,
                maxChars: number,
            }),
        ),
    }),
    mobileAgeVerificationOpen: bool,
    hasWine: bool,
    handleMobileAgeVerification: () => { },
    addToCartData: addToCartDataType,
    addonGroups: addonGroupsType,
    deliverySLA: string.isRequired,
    deviceType: string,
    deliveryIndicator: string.isRequired,
    isPassportAfterCta: bool,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
    brand: getBrand(state),
});

const mapDispatchToProps = {
    trackEvent: tagManagerActions.trackEvent,
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
);

export default enhance(GraphqlClubProductPage);
